// File: client/src/variants/chaos/rulebook.js
// Canonical rulebook for Chaos Chess.

const rulebook = {
  overview:
    'The ultimate sandbox — build your own variant. Chaos Chess lets you switch independent subsystems on or off: random events, a shrinking Royale board, periodic gravity, and meteor strikes. Mix and match for a game that’s exactly as wild as you want.',
  objective:
    'Checkmate the opponent’s king — or, if the shrinking board is on, be the last king standing.',
  setup:
    'Standard starting position. The enabled subsystems (shown at the top of the screen) drive the chaos. With no toggles on, Chaos Chess is simply classic chess.',
  turnFlow: [
    'Make one normal legal move.',
    'After each move, every enabled subsystem takes its scheduled action (events, shrink, gravity, meteors).',
    'The active toggles are always listed at the top of the screen.',
  ],
  mechanics: [
    {
      title: 'Toggleable subsystems',
      items: [
        '🎲 Random Events — a random board modifier fires every few full turns.',
        '🌀 Shrinking Board — the arena collapses over time (Chess Royale); a king caught outside is eliminated.',
        '⬇️ Periodic Gravity — every few turns, all pieces fall to the bottom of their columns.',
        '☄️ Periodic Meteors — every few turns, a random non-king piece is destroyed.',
      ],
    },
    {
      title: 'How toggles combine',
      body: 'Each subsystem is independent and conflict-free — they are composed together so enabling several simply stacks their effects. Because they never fight over the same mechanic, any combination is stable.',
    },
  ],
  winConditions: [
    'Win by checkmate.',
    'With the shrinking board on, also win by being the last king alive (a king lost to the collapsing ring loses the game).',
    'Win if the opponent resigns or runs out of time. Stalemate is a draw.',
  ],
  tips: [
    'Start with one toggle to learn its rhythm, then layer more.',
    'Shrinking board + random events is a fast, brutal combination — keep your king central.',
    'With everything off, it’s a clean game of classic chess.',
  ],
  knownInteractions: [
    'Rule decision: subsystems are curated to be independent and composable, rather than merging whole variant runtimes (which could conflict over turn flow / board mutation). This keeps every combination stable and bug-free.',
    'Rule decision: with the shrinking board enabled, king-elimination victory takes precedence over checkmate on the turn the ring collapses (as in Chess Royale).',
    'Rule decision: kings are never destroyed by events, gravity, or meteors (only by the shrinking ring).',
    'Rule decision: the current build applies the default toggle set (random events on; shrink/gravity/meteor off). The settings schema is defined so a setup UI can expose the toggles; wiring that UI is a follow-up.',
    'AI: the computer plays standard chess and is not subsystem-aware. Board changes affect it equally; documented limitation.',
  ],
};

export default rulebook;
